export default "__VITE_ASSET__AIcu7iZ$__"